<div class="milestone_container" id="myDIV">
  <svg xmlns="http://www.w3.org/2000/svg" height="1000" [attr.viewBox]="viewbox">
    @for (week of arrayOf(weeks); track week; let d = $index) {
      <svg y="0" x="310">
        @for (week of arrayOf(7); track week; let a = $index) {
          <g>
            <!-- <rect class=dayBox width="30" [attr.height]="viewboxWhide" fill="red"/> -->
            <line [attr.x1]="(30*7*d)+(30*a)" y1="30" [attr.x2]="(30*7*d)+(30*a)" [attr.y2]="viewboxWhide" style="stroke:rgb(230,230,230);stroke-width:1" />
          </g>
        }
      </svg>
    }
    @for (itm of list; track itm; let i = $index) {
      <svg class="parent_milestones" [attr.y]="checkY(itm, i)" [attr.x]="checkX(itm)">
        <line x1="310" y1="30" [attr.x2]="svgwidth" y2="30" style="stroke:rgb(230,230,230);stroke-width:1" />
        @if (itm.childs.length > 0) {
          <svg y="0" [attr.x]="310">
            <rect height="30" [attr.width]="checkBoxWidth(itm)" [attr.x]="checkBoxStart(itm)" y="0" [attr.fill]="checkBackground(itm)" stroke="rgb(230,230,230)" />
          </svg>
        }
        @if (itm.childs.length == 0) {
          <svg y="0" x="310">
            @for (ch of itm['chapters']; track ch) {
              <g>
                <rect height="30" [attr.width]="checkBoxWidth(ch)" [attr.x]="checkBoxStart(ch)" y="0" [attr.fill]="checkBackground(itm)" stroke="rgb(230,230,230)" />
                <text class="milestone" fill="rgb(50,50,50)" y="20" [attr.x]="checkBoxStart(ch) + (checkBoxWidth(ch) / 2)" text-anchor="middle">
                  {{ch.chapter_number}}
                </text>
              </g>
            }
          </svg>
        }
        @for (child of itm.childs; track child; let a = $index) {
          <svg class="child_milestones" x="20" [attr.y]="30 + (a * 30)">
            <line x1="290" y1="30" [attr.x2]="svgwidth" y2="30" style="stroke:rgb(230,230,230);stroke-width:1" />
            <svg y="0" x="290">
              @for (ch of child['chapters']; track ch) {
                <g>
                  <rect height="30" [attr.width]="checkBoxWidth(ch)" [attr.x]="checkBoxStart(ch)" y="0" fill="white" [attr.stroke]="child.color_code" />
                  <text class="milestone" [attr.fill]="child.color_code" y="20" [attr.x]="checkBoxStart(ch) + (checkBoxWidth(ch) / 2)" text-anchor="middle">
                    {{ch.chapter_number}}
                  </text>
                </g>
              }
            </svg>
          </svg>
        }
      </svg>
    }

    @for (itm of list; track itm; let i = $index) {
      <svg class="parent_milestones" [attr.y]="checkY(itm, i)" [attr.x]="0 + scrollPositionX">
        <g (contextmenu)="_gS.rigthClick($event, 3); selectMilestone(itm)" >
          <rect  height="30" [attr.width]="300" x="0" y="0" fill="white" stroke="rgb(230,230,230)"/>
          <circle cx="15" cy="15" r="6" [attr.stroke]="itm.color_code" stroke-width="1" [attr.fill]="checkBackground(itm)"/>
          <text class="milestone" fill="rgb(50,50,50)" y="20" x="26">
            {{itm.milestone_name}}
            <!-- <tspan>s:{{itm.to_start}} ({{checkTypeDuration(itm.to_start_duration_type_id)}}) d:{{itm.duration}} ({{checkTypeDuration(itm.duration_type_id)}})</tspan> -->
          </text>
        </g>
        @for (child of itm.childs; track child; let a = $index) {
          <svg class="child_milestones" x="0" [attr.y]="30 + (a * 30)">
            <g (contextmenu)="_gS.rigthClick($event, 3); selectMilestone(child)" >
              <rect  height="30" [attr.width]="300" x="0" y="0" fill="white" stroke="rgb(230,230,230)" />
              <circle cx="25" cy="15" r="6" [attr.stroke]="child.color_code" stroke-width="1" fill="white" />
              <text class="milestone" fill="rgb(50,50,50)" y="20" x="41">
                {{child.milestone_name}}
                <!-- <tspan>
                s:{{child.to_start}} ({{checkTypeDuration(child.to_start_duration_type_id)}}) d:{{child.duration}} ({{checkTypeDuration(child.duration_type_id)}})
              </tspan> -->
            </text>
          </g>
        </svg>
      }
    </svg>
  }
  @for (week of arrayOf(weeks); track week; let d = $index) {
    <svg [attr.y]="0 + scrollPositionY" x="310">
      <rect  height="30" [attr.width]="30 * 7" [attr.x]="30*7*d" y="0" fill="rgb(250,250,250)" stroke="rgb(230,230,230)" />
      <text class="milestone" fill="rgb(50,50,50)" y="20" [attr.x]="30*7*d + (15 * 7)"  text-anchor="middle">
        {{'week' | translate}}: {{d+1}}
      </text>
      @for (week of arrayOf(7); track week; let a = $index) {
        <g>
          <rect  height="20" width="30" [attr.x]="(30*7*d)+(30*a)" y="30" fill="rgb(240,240,240)" stroke="rgb(230,230,230)" />
          <text class="milestone" fill="rgb(50,50,50)" y="44" [attr.x]="(30*7*d)+(30*a) + (15)"  text-anchor="middle">
            {{checkDay(a)}}
          </text>
        </g>
      }
    </svg>
  }
  <svg [attr.y]="0 + scrollPositionY" [attr.x]="0 + scrollPositionX">
    <rect height="50"  width="300" y="0" x="0" fill="white"/>
  </svg>
</svg>
</div>